export class SavedSearchModel {
  public uuid: string;
  public name: string;
  public querystring: string;
  public query_label: string;
  public resultCount: number;
  public editable?: boolean;

  constructor(values?: Partial<SavedSearchModel>) {
    Object.assign(this, values);
  }
}
